export const environment = {
  production: true,
  origin: 'https://www.pygmalios.com',
  storyblok_api_key: 'YkBCult4M7c44PFFAhQNvgtt',
  storyblok_api_version: 'published',
  recaptcha_site_key: '6LeGCUseAAAAADr3QhcPo_4L-HyQCKy9yQKD2yri',
};
